import {Route,Switch,BrowserRouter } from "react-router-dom";

import AdminParamsTable from "components/Doobi/AdminParams";
import DoobiHeader from "components/Headers/DoobiHeader";

const AdminParamsRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="AdminParams" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={AdminParamsTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default AdminParamsRoute;
